export interface SupportTicket {
  id: string;
  company_id: string;
  user_id: string;
  subject: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  category: string;
  created_at: string;
  updated_at: string;
  user_name?: string;
  user_avatar?: string;
}

export interface SupportTicketMessage {
  id: string;
  ticket_id: string;
  user_id: string;
  is_admin: boolean;
  message: string;
  created_at: string;
  user_name?: string;
}

export const mockTickets: SupportTicket[] = [
  {
    id: 't1',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Erro ao conectar WhatsApp Business API',
    status: 'open',
    priority: 'high',
    category: 'whatsapp',
    created_at: '2026-08-05T10:30:00Z',
    updated_at: '2026-08-05T10:30:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
  {
    id: 't2',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Dúvida sobre planos e créditos de envio',
    status: 'in_progress',
    priority: 'medium',
    category: 'billing',
    created_at: '2026-08-04T14:20:00Z',
    updated_at: '2026-08-05T09:15:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
  {
    id: 't3',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Recuperar campanha excluída acidentalmente',
    status: 'resolved',
    priority: 'urgent',
    category: 'campaigns',
    created_at: '2026-08-03T08:45:00Z',
    updated_at: '2026-08-04T16:30:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
  {
    id: 't4',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Template de mensagem rejeitado pelo WhatsApp',
    status: 'open',
    priority: 'medium',
    category: 'templates',
    created_at: '2026-08-06T07:00:00Z',
    updated_at: '2026-08-06T07:00:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
  {
    id: 't5',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Integração com CRM externo',
    status: 'closed',
    priority: 'low',
    category: 'integrations',
    created_at: '2026-07-28T11:00:00Z',
    updated_at: '2026-08-01T10:00:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
  {
    id: 't6',
    company_id: 'c1',
    user_id: 'u1',
    subject: 'Exportação de relatórios em PDF travando',
    status: 'in_progress',
    priority: 'high',
    category: 'reports',
    created_at: '2026-08-05T16:45:00Z',
    updated_at: '2026-08-06T08:30:00Z',
    user_name: 'João Silva',
    user_avatar: 'JS',
  },
];

export const mockMessages: Record<string, SupportTicketMessage[]> = {
  t1: [
    {
      id: 'm1',
      ticket_id: 't1',
      user_id: 'u1',
      is_admin: false,
      message: 'Olá! Estou tentando conectar minha conta do WhatsApp Business pela API e recebo o erro "Invalid access token" mesmo depois de gerar um token novo várias vezes. Já verifiquei as permissões no Meta Business e está tudo certo.',
      created_at: '2026-08-05T10:30:00Z',
      user_name: 'João Silva',
    },
  ],
  t2: [
    {
      id: 'm2',
      ticket_id: 't2',
      user_id: 'u1',
      is_admin: false,
      message: 'Bom dia! Estou no plano Professional e gostaria de saber se posso comprar créditos extras de envio sem fazer upgrade de plano. Preciso enviar cerca de 80 mil mensagens este mês.',
      created_at: '2026-08-04T14:20:00Z',
      user_name: 'João Silva',
    },
    {
      id: 'm3',
      ticket_id: 't2',
      user_id: 'admin1',
      is_admin: true,
      message: 'Olá João! Sim, você pode comprar créditos avulsos sem fazer upgrade. Vá em Configurações > Uso e Créditos e clique em "Comprar Créditos". Cada lote de 5.000 mensagens custa R$ 30. Ou se preferir, posso gerar um link de pagamento direto para você.',
      created_at: '2026-08-05T09:15:00Z',
      user_name: 'Equipe WZap',
    },
  ],
  t3: [
    {
      id: 'm4',
      ticket_id: 't3',
      user_id: 'u1',
      is_admin: false,
      message: 'URGENTE! Excluí sem querer a campanha "Black Friday — Aquecimento" que estava programada. Tem como recuperar? Ela tinha 3.200 contatos configurados.',
      created_at: '2026-08-03T08:45:00Z',
      user_name: 'João Silva',
    },
    {
      id: 'm5',
      ticket_id: 't3',
      user_id: 'admin1',
      is_admin: true,
      message: 'João, fique tranquilo! Localizei o backup da sua campanha de 02/08. Restaurei ela como rascunho — está na sua lista de campanhas com o nome "Black Friday — Aquecimento (Restaurada)". Os 3.200 contatos estão preservados.',
      created_at: '2026-08-03T09:10:00Z',
      user_name: 'Equipe WZap',
    },
    {
      id: 'm6',
      ticket_id: 't3',
      user_id: 'u1',
      is_admin: false,
      message: 'Ufa, salvou o dia! Muito obrigado pelo atendimento rápido. Tudo certo por aqui.',
      created_at: '2026-08-03T09:25:00Z',
      user_name: 'João Silva',
    },
  ],
  t4: [
    {
      id: 'm7',
      ticket_id: 't4',
      user_id: 'u1',
      is_admin: false,
      message: 'Meu template "Confirmação de Pedido" foi rejeitado pelo WhatsApp com o motivo "conteúdo promocional". Mas é apenas uma confirmação de pedido com número do pedido e link de rastreio. Não tem nada promocional. Podem revisar?',
      created_at: '2026-08-06T07:00:00Z',
      user_name: 'João Silva',
    },
  ],
  t5: [
    {
      id: 'm8',
      ticket_id: 't5',
      user_id: 'u1',
      is_admin: false,
      message: 'Gostaria de integrar o WZap com nosso CRM (Pipedrive). Existe integração nativa ou preciso usar webhooks?',
      created_at: '2026-07-28T11:00:00Z',
      user_name: 'João Silva',
    },
    {
      id: 'm9',
      ticket_id: 't5',
      user_id: 'admin1',
      is_admin: true,
      message: 'Temos integração via webhooks! Você pode configurar em Configurações > Integrações > Webhooks. Temos um guia específico para Pipedrive. Também estamos desenvolvendo a integração nativa que será lançada em Setembro/2026.',
      created_at: '2026-07-28T14:30:00Z',
      user_name: 'Equipe WZap',
    },
  ],
  t6: [
    {
      id: 'm10',
      ticket_id: 't6',
      user_id: 'u1',
      is_admin: false,
      message: 'Quando tento exportar o relatório mensal em PDF, a tela fica carregando infinitamente. Já tentei no Chrome e Firefox. O relatório tem dados de 3 campanhas.',
      created_at: '2026-08-05T16:45:00Z',
      user_name: 'João Silva',
    },
    {
      id: 'm11',
      ticket_id: 't6',
      user_id: 'admin1',
      is_admin: true,
      message: 'Identificamos o problema — acontece com relatórios que têm mais de 2.500 registros. Nossa equipe de engenharia já está corrigindo. Enquanto isso, tente exportar campanha por campanha que funciona normalmente. Prazo de correção: 24-48h.',
      created_at: '2026-08-06T08:30:00Z',
      user_name: 'Equipe WZap',
    },
  ],
};

export const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
  open: { label: 'Aberto', color: 'text-amber-600 dark:text-amber-400', bg: 'bg-amber-50 dark:bg-amber-500/10' },
  in_progress: { label: 'Em Andamento', color: 'text-sky-600 dark:text-sky-400', bg: 'bg-sky-50 dark:bg-sky-500/10' },
  resolved: { label: 'Resolvido', color: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-500/10' },
  closed: { label: 'Fechado', color: 'text-foreground-500', bg: 'bg-background-100 dark:bg-background-200' },
};

export const priorityConfig: Record<string, { label: string; color: string }> = {
  low: { label: 'Baixa', color: 'text-foreground-500' },
  medium: { label: 'Média', color: 'text-sky-600 dark:text-sky-400' },
  high: { label: 'Alta', color: 'text-amber-600 dark:text-amber-400' },
  urgent: { label: 'Urgente', color: 'text-red-600 dark:text-red-400' },
};

export const categoryConfig: Record<string, { label: string; icon: string }> = {
  general: { label: 'Geral', icon: 'ri-question-line' },
  whatsapp: { label: 'WhatsApp', icon: 'ri-whatsapp-line' },
  billing: { label: 'Financeiro', icon: 'ri-bank-card-line' },
  campaigns: { label: 'Campanhas', icon: 'ri-megaphone-line' },
  templates: { label: 'Templates', icon: 'ri-file-text-line' },
  contacts: { label: 'Contatos', icon: 'ri-contacts-book-line' },
  integrations: { label: 'Integrações', icon: 'ri-plug-line' },
  reports: { label: 'Relatórios', icon: 'ri-bar-chart-box-line' },
  settings: { label: 'Configurações', icon: 'ri-settings-3-line' },
};